import router from '@/router';
import route from '@/router';

export default {
    resetGameOptions(context) {
        context.commit('updateStep', 1);
        context.commit('resetOptions');
    },
    saveSelectedMaterial(context, {id, data, budgetRoute = false}) {
        context.commit('saveMaterial', {id, data});

        const dataIds = data.map(material => material.uniqueId);
        let phaseId;

        context.getters.getSavedMaterials.forEach(phase => {
            if (phase.disabledByMaterial) {
                phase.disabledByMaterial.forEach(mat => {
                    if (dataIds.includes(mat.id)) {
                        phaseId = phase.id; 
                    }
                });
            }
        });

        if (phaseId) {
            const phaseIndex = context.state.buildingPhases.savedMaterials.findIndex(phase => phase.id == phaseId);

            if (context.state.buildingPhases.savedMaterials[phaseIndex].data.length) {
                context.state.buildingPhases.savedMaterials[phaseIndex].data.forEach(material => {
                    if (material.buidlingVectaryModel) {
                        material.buidlingVectaryModel.forEach(object => {
                            context.state.model.setVisibility(object.vectaryId, false, false);
                        });
                    }
                });
            }

            context.state.buildingPhases.savedMaterials[phaseIndex].data = [];
        }

        if (budgetRoute) {
            router.push({name: 'budget'});
        } else if (route.currentRoute.value.params.editing == 'true') {
            router.push({name: 'game-overview'});
        } else {
            router.push({name: 'game'});
        }
    },
    resetGameMaterials(context) {
        context.commit('updatePhase', 0);
        context.commit('resetSavedMaterials');
        context.commit('resetModel');
        router.push({name: 'game'});
    },
    resetGame(context) {
        context.dispatch('resetGameOptions');
        context.commit('updatePhase', 0);
        context.commit('resetSavedMaterials');
        context.commit('resetResult');
        document.body.classList.toggle('no-scroll');
        router.push({name: 'game-options'});
    }
};
